import React, { useContext, useEffect } from 'react';
import { Box, Typography, Button, ButtonBase, Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ShoppingCartProductsContext } from '../contexts/ShoppingCartProductsContext';
import { layoutButtonPillRadius, layoutIconButtonRadius } from '../theme/colors';
import TudoPetsLogo from '../images/tp_logo_laranja.png';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Landing after checkout redirect (Pix / card). Clears cart if session still had items.
 * UI from design-v2; cart reset kept from master-v2 for Stripe flows.
 */
const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const { setTotalQuantity, setTotalAmount, setShoppingCartProducts } = useContext(
    ShoppingCartProductsContext,
  );

  useEffect(() => {
    localStorage.setItem('shoppingCartProducts', '[]');
    localStorage.setItem('totalAmount', '0');
    localStorage.setItem('totalQuantity', '0');
    setTotalAmount(0);
    setTotalQuantity(0);
    setShoppingCartProducts([]);
    document.title = 'Pedido confirmado - TudoPets.app';
  }, [setShoppingCartProducts, setTotalAmount, setTotalQuantity]);

  const handleHome = () => {
    navigate('/home');
  };

  const handleOrders = () => {
    navigate('/orders');
  };

  const buttonStyle = {
    display: 'flex',
    width: '100%',
    p: '16px 0',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    borderRadius: layoutButtonPillRadius,
    fontFamily: 'Nunito',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    color: 'primary.contrastText',
  };

  const columnCentered = {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'stretch',
    gap: 2,
    alignItems: 'center',
  };

  return (
    <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
      <Card
        sx={{
          display: 'flex',
          p: 4,
          flexDirection: 'column',
          gap: '24px',
          alignItems: 'flex-start',
          maxWidth: '420px',
          mt: 4,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            gap: '24px',
            alignSelf: 'stretch',
          }}
        >
          <Button data-no-shadow="true" onClick={handleHome} sx={{ borderRadius: layoutIconButtonRadius }}>
            <CloseIcon sx={{ color: 'text.primary' }} />
          </Button>
        </Box>

        <Box sx={{ ...columnCentered }}>
          <Box component="img" src={TudoPetsLogo} alt="Logo TudoPets" sx={{ width: '100%', height: 'auto', p: 2 }} />
        </Box>

        <Typography
          variant="pageTitle"
          sx={{
            // Success hero — 32px Calistoga (larger than pageTitle); keep inline until reused 3+ times
            fontSize: '32px',
            lineHeight: '41.6px',
            color: 'text.primary',
            textAlign: 'left',
          }}
        >
          Pedido feito com sucesso!
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Nunito',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            color: 'text.secondary',
            textAlign: 'left',
          }}
        >
          Seu pedido foi realizado com sucesso! Em breve você receberá um e-mail com todos os detalhes da sua
          compra. Estamos felizes que você tenha comprado conosco!
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '10px', alignSelf: 'stretch' }}>
          <ButtonBase onClick={handleHome} sx={{ ...buttonStyle, bgcolor: 'primary.main' }}>
            Voltar para tela inicial
          </ButtonBase>
          <ButtonBase onClick={handleOrders} sx={{ ...buttonStyle, bgcolor: 'secondary.dark' }}>
            Ver pedido
          </ButtonBase>
        </Box>
      </Card>
    </Box>
  );
};

export default CheckoutSuccess;
